module.exports = __webpack_public_path__ + "static/littleWomen10-96cceb18d398ea31ad258003577a6177.jpg";